<template>
    <div>
        <UEditor ref="ue"></UEditor>
        <button @click="getContent()">获取内容</button>
    </div>
</template>

<script>
    import UEditor from '@/common/UEditor'

    export default {
      components: { UEditor },
      name:'RichText',
      data() {
        return {
        }
      },
      methods: {
        getContent() {
          console.log('html', this.$refs.ue.contents)
        }
      }
    }

</script>
<style scoped>
</style>
